import { ApplicationState } from '@app/store'
import * as GlobalState from '@app/store/modules/global'
import { connect } from 'react-redux'
import ReactiveLayout from '../components/ReactiveLayout'
import {
  actionCreators,
  selectReactiveLayoutState,
} from '../modules/ReactiveLayout'

export default connect(
  selectReactiveLayoutState(),
  Object.assign({}, actionCreators, GlobalState.actionCreators),
)(ReactiveLayout)
